export enum DeliveryMethod {
  MTicket = 0,
  Swift = 1,
}
